<div [formGroup]="form">
  <aur-dropdown
    id="language-dropdown"
    class="full-width"
    panelStyleClass="language-dropdown-panel"
    [options]="languageDropdownOptions"
    formControlName="selectedLanguage"
  >
    <ng-template aurTemplate="selectedItem">
      <ng-container
        [ngTemplateOutlet]="LANG_TEMPLATE"
        [ngTemplateOutletContext]="{ $implicit: form.get('selectedLanguage') }"
      ></ng-container>
    </ng-template>
  </aur-dropdown>

  <ng-template #LANG_TEMPLATE let-control>
    <span class="selected-language">
      <aur-icon class="language-icon" color="inherit" size="sm"
        >language</aur-icon
      >
      <span class="language-name">{{ control?.value?.name }}</span>
    </span>
  </ng-template>
</div>
